import { atom } from 'jotai';

/**
 * Identifies the section currently showing the "copied" success indicator.
 * The value is a per-instance React `useId()` from `SectionNodeComponent`, not
 * the human-readable section title — otherwise two sections with identical
 * titles would collide (both buttons would flip to success, and one timer
 * could clear the other's state).
 */
export const copiedSectionAtom = atom<string | null>(null);
